import sample_01 from './dynamic-allround-chem.jpg';
import sample_02 from './dynamic-allround-chem-2.jpg';

export const dynamicAllroundChemImpressions = {
    sample_02,
    sample_01,
};
